import { render, staticRenderFns } from "./SMSAuthStep02Form.vue?vue&type=template&id=d4fed074"
import script from "./SMSAuthStep02Form.vue?vue&type=script&lang=js"
export * from "./SMSAuthStep02Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports